import { SUBSCRIPTION_STATES } from '../../../../../constants/subscriptions';

import { ISubscriptionWellfunnel } from '../../../../../api/components/Subscriptions/types';

const COUNTRIES_WITHOUT_DISCOUNT_OFFER = ['PH', 'ZA', 'TW'];

export const checkDiscountAllowed = (country: string | null) =>
    country ? !COUNTRIES_WITHOUT_DISCOUNT_OFFER.includes(country) : false;

export const getSubscriptionIdsWithoutReminder = (subscriptions: ISubscriptionWellfunnel[]) =>
    subscriptions.reduce((acc, { reminder, external_id }) => {
        if (!reminder) {
            acc.push(external_id);
        }

        return acc;
    }, [] as string[]);

export const getActiveSubscriptionIds = (subscriptions: ISubscriptionWellfunnel[]) =>
    subscriptions.reduce((acc, { external_id, state }) => {
        if (state === SUBSCRIPTION_STATES.ACTIVE) {
            acc.push(external_id);
        }

        return acc;
    }, [] as string[]);
